module.exports = __webpack_public_path__ + "img/blog7.9dec8bad.png";